export { complianceRoute } from './constants';
export { ComplianceComponent } from './compliance.component';